import {
  useWSModal,
  useWSSnackbar,
  WSActions,
  WSAlert,
  WSText
} from "@wingspanhq/fe-component-library";
import { IEngagement } from "@wingspanhq/payments/dist/interfaces";
import { WSErrorMessage } from "../../../components/WSErrorMessage/WSErrorMessage";
import React from "react";
import { ErrorContextKey } from "../../../services/platform";
import { ActionEngagementDetails } from "../components/ActionEngagementDetails";
import { useDeleteEngagement } from "../../../query/engagements/mutations/useDeleteEngagement";

export interface DeleteEngagementTypeModalProps {
  engagement: IEngagement;
  onSuccess: (engagement: IEngagement) => void;
  onClose: () => void;
}

export const DeleteEngagementTypeModal: React.FC<
  DeleteEngagementTypeModalProps
> = ({ engagement, onClose, onSuccess }) => {
  const { openSnackbar } = useWSSnackbar();
  const [deleteEngagementType, deleteEngagementTypeMeta] =
    useDeleteEngagement();

  const handleDelete = async () => {
    await deleteEngagementType(engagement.engagementId);

    openSnackbar({
      theme: "dark",
      type: "success",
      message: "Engagement type deleted"
    });
    onSuccess(engagement);
    onClose();
  };

  return (
    <>
      <WSText.ParagraphSm mb="L" weight="book">
        Are you sure you want to delete this engagement type?
      </WSText.ParagraphSm>
      <ActionEngagementDetails engagement={engagement} />

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Deleting engagement type"
      >
        Deletion is a permanent action, it cannot be restored.
      </WSAlert>

      <WSErrorMessage
        error={deleteEngagementTypeMeta.error}
        mb="XL"
        contextKey={ErrorContextKey.Engagement}
      />

      <WSActions
        alignment="fill"
        sortButtons={false}
        buttons={[
          {
            label: "Cancel",
            onClick: onClose,
            kind: "Secondary"
          },
          {
            label: "Delete engagement type",
            loading: deleteEngagementTypeMeta.isLoading,
            onAsyncClick: handleDelete,
            kind: "Primary",
            destructive: true
          }
        ]}
      />
    </>
  );
};

export const useDeleteEngagementTypeModal = () => {
  return useWSModal(DeleteEngagementTypeModal, {
    title: "Delete engagement type",
    size: "M"
  });
};
